module.exports = __webpack_public_path__ + "media/icons/zmiana-rejestracji-ea003b07.png";